import React from 'react'
import { Helmet } from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { AboutPage } from 'schema-dts'

import useUrlPathBuilder from '../../hooks/useUrlPathBuilder'
import { LandingPageV2 } from '../../types/landingPageV2'
import { LandingPage } from '../../types/landingPage'
import { ReviewPage } from '../../types/review'
import { FAQPage } from '../../types/faq'
import { ProductPage } from '../../types/productPageV2'

interface Props {
  landingPage: LandingPageV2 | LandingPage | FAQPage | ReviewPage | ProductPage
}

const AboutPageSEO: React.FC<Props> = ({ landingPage }) => {
  const { urlPathBuilder, baseURL } = useUrlPathBuilder()

  return (
    <Helmet
      script={[
        helmetJsonLdProp<AboutPage>({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: landingPage.seo?.pageTitle ?? landingPage.title,
          description: landingPage.seo?.description ?? undefined,
          url: urlPathBuilder([landingPage.slug], { baseURL }),
          isPartOf: {
            '@id': urlPathBuilder([landingPage.slug], {
              baseURL,
              hash: 'webpage',
            }),
          },
        }),
      ]}
    />
  )
}

export default AboutPageSEO
